
/**
 * Generates a structured data object for the application
 */
export function generateAppStructuredData(customFields = {}) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Hour Tracker",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "A simple, secure way to track your billable hours and generate professional invoices. Perfect for freelancers and small businesses.",
    ...customFields
  };
}

/**
 * Generates structured data for a specific web page
 */
export function generatePageStructuredData(title: string, description: string, url: string, customFields = {}) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": url,
    ...customFields
  };
}

/**
 * Generates structured data for an organization
 */
export function generateOrganizationStructuredData(customFields = {}) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Hour Tracker",
    "url": "https://www.hourtracker.info",
    "logo": "https://www.hourtracker.info/lovable-uploads/1cb2ed67-a994-4bc8-8c45-2e0bb7eba942.png",
    "sameAs": [],
    ...customFields
  };
}

/**
 * Generates breadcrumb structured data
 */
export function generateBreadcrumbStructuredData(items: {name: string, url: string}[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
}

/**
 * Generates structured data for a FAQ page
 */
export function generateFAQStructuredData(questions: {question: string, answer: string}[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": questions.map(q => ({
      "@type": "Question",
      "name": q.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": q.answer
      }
    }))
  };
}
